import { useMemo } from 'react';

import Button from 'react-bootstrap/Button';
import { IS_NATERA, PRODUCT_ID_DATA_ONLY } from '@constants/constants';
import { formatDateForDisplay } from '@helpers/date';
import { Requisition } from '@customTypes/requisition';
import { useDownload } from '@hooks/useDownload';

interface IProps {
  requisition: Requisition;
}

export default function RequisitionDocuments({ requisition }: IProps) {
  const { onDownload, onClinicalSummaryLetterDownload } = useDownload();
  const documentGroupClasses = IS_NATERA ? 'border border-accent-subtle rounded-2' : 'rounded-3 bg-light';
  const rqIdFontWeight = IS_NATERA ? '' : 'fw-bold';

  const orders = useMemo(
    () =>
      requisition.orders
        .filter(order => order.product_id !== PRODUCT_ID_DATA_ONLY)
        .map(order => ({
          ...order,
          linkText: order.product_name + ' Report',
        })),
    [requisition.orders],
  );

  return (
    <div className={`d-flex flex-column gap-2 p-2 pb-3 requisition-documents ${documentGroupClasses}`}>
      <div>
        <span className='fs-xs lh-xs fw-bold text-secondary'>Order ID:</span>
        <p className={`mb-0 fs-5 lh-xs ${rqIdFontWeight}`}>{requisition.requisition_id}</p>
      </div>

      <ul className='mb-0 ps-0 d-flex flex-column gap-2 list-style-none'>
        {orders.map(order => (
          <li key={order.order_id} className='px-1'>
            <Button
              variant='link'
              className='p-0 fw-medium text-start'
              onClick={() => onDownload(order, requisition.requisition_id)}
            >
              {order.linkText}
            </Button>
            <p className='mb-0 text-secondary'>{formatDateForDisplay(order.reported_at)}</p>
          </li>
        ))}
        {!!requisition.clinical_summary_letter && (
          <li className='px-1'>
            <Button
              variant='link'
              className='p-0 fw-medium text-start'
              onClick={() => onClinicalSummaryLetterDownload(requisition)}
            >
              Clinical Summary Letter
            </Button>
            <p className='mb-0 text-secondary'>
              {formatDateForDisplay(requisition.clinical_summary_letter.completed_on)}
            </p>
          </li>
        )}
      </ul>
    </div>
  );
}
